var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ul',{staticClass:"el-menu--horizontal"},_vm._l((_vm.realMenuList),function(i){return _c('li',{key:i.name,class:`el-menu-item ${_vm.$route.path.includes(i?.url) ? 'is-active':''}`,on:{"click":function($event){return _vm.handleSelect(i.url)}}},[_vm._v(_vm._s(i.name))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }